import { useRouter } from '@application/utils';
import { ProfessionalTypeEnum } from '@gql/graphql';
import type { Route } from '@application/types';
import type { RelatedLinksCategory, RelatedLinksData } from '@presentation/components';
import { isEmpty } from 'lodash/fp';
import { useMemo } from 'react';
import { useGetRelatedProfessionals } from './useGetRelatedProfessionals';
import type { RelatedProfessionalsParams } from './useGetRelatedProfessionals';
import { useFormatRelatedPros } from './useFormatOtherPro';

// TODO: refactor, this is ugly

export const useRelatedLinks = (params: RelatedProfessionalsParams) => {
  const { nearByPoint, proType, proId } = params;
  const { translate, routeLocationDescriptor } = useRouter();
  const { locations, otherPros, relatedProsLoading } = useGetRelatedProfessionals({
    proId,
    proType,
    nearByPoint,
  });
  const { formattedPros } = useFormatRelatedPros(otherPros);

  const formattedLocations = useMemo((): RelatedLinksCategory | undefined => {
    if (relatedProsLoading) return undefined;
    if (!locations.length) return undefined;

    let label: Route = 'vet';
    let link: Route = 'vetList';
    if (proType === ProfessionalTypeEnum.GROOMER) label = 'groomer';
    else if (proType === ProfessionalTypeEnum.EDUCATOR) label = 'educator';
    if (proType === ProfessionalTypeEnum.GROOMER) link = 'groomerList';
    else if (proType === ProfessionalTypeEnum.EDUCATOR) link = 'educatorList';
    return {
      label: translate('proList.relatedLinks.otherRegions'),
      items: locations
        .filter((x) => !!x?.city)
        .map((x) => ({
          label: translate(`links.${label}.list.link`).replace('$city', x!.city as string),
          link: routeLocationDescriptor(link, {
            params: [x!.city as string],
          }),
        })),
    };
  }, [locations, relatedProsLoading, proType, routeLocationDescriptor, translate]);

  const formattedRelatedPros = useMemo((): RelatedLinksCategory | undefined => {
    if (!formattedPros?.length) return undefined;

    return {
      label: translate(`proList.relatedLinks.otherPros.${proType}`),
      items: formattedPros,
    };
  }, [formattedPros, proType, translate]);

  const relatedLinks = useMemo((): RelatedLinksData | undefined => {
    const links = {
      categories: [
        ...(formattedLocations ? [formattedLocations] : []),
        ...(formattedRelatedPros ? [formattedRelatedPros] : []),
      ].filter((x) => !!x),
    };
    if (isEmpty(links.categories)) return undefined;
    return links;
  }, [formattedLocations, formattedRelatedPros]);

  return { relatedLinks, loading: relatedProsLoading };
};
